class ProductFilters extends HTMLElement {
  constructor() {
    super();
    this.selectedParts = [];
    this.url = '';
    this.collectionHandle = this.getAttribute('collectionHandle') || '';
    this.collectionUrl = this.getAttribute('collectionUrl') || '';
    this.toggleBtn = this.querySelector('.toggle-filters')
    this.selectedFilters = document.querySelectorAll('.filter-item--active').length;
    document.getElementById('selected-items-count').innerHTML = this.selectedFilters > 0 ? `(${this.selectedFilters})` : '';
    this.clear = this.querySelector('.collection__filters-clear-js')

    if(document.querySelectorAll('.filter-item--active').length > 0) {
      this.clear.classList.remove('hidden')
    }
  }

  connectedCallback() {
    this.filterLinks = this.querySelectorAll(".js-filter-item a");
    this.applyButtons = this.querySelectorAll(".js-collection__filters-apply");
    this.filterContainer = this.querySelector("slide-panel[slidepanelid='toggle-filters']");


    if (!this.collectionHandle || !this.collectionUrl) return;

    this.updateSelectedPartsFromUrl();
    this.initializeEventListeners();
    this.addClickOutsideListener();
  }

  updateSelectedPartsFromUrl() {
    const urlParts = window.location.pathname.split("/").filter(part => part !== "");
    const lastPart = urlParts[urlParts.length - 1];

    if (lastPart && lastPart !== this.collectionHandle) {
      this.selectedParts = lastPart.split("+");
    }
  }

  initializeEventListeners() {
    this.filterLinks.forEach(link => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        this.handleFilterLinkClick(link);
      });
    });

    this.applyButtons.forEach(applyButton => {
      applyButton.addEventListener("click", () => {
        this.applyFilters();
      });
    });

    if (this.toggleBtn) {
      this.toggleBtn.addEventListener("click", () => {
        this.toggleFilter();
      });
    }
    if (window.innerWidth > 1024) {
      this.updatePanelPosition()
      window.addEventListener('scroll', () => this.updatePanelPosition());
    }
  }

  updatePanelPosition() {
    const toggleButtonRect = this.toggleBtn.getBoundingClientRect();
    this.filterContainer.style.top = `${toggleButtonRect.top + toggleButtonRect.height + 10}px`;
  }

  handleFilterLinkClick(link) {
    const linkHandle = link.getAttribute("data-handle");

    if (!linkHandle) return;

    // Extract the filter type (e.g., "size" or "color") from the linkHandle
    const [filterType] = linkHandle.split("-");

    // Check if this option is already active
    const isAlreadySelected = link.classList.contains("filter-item--active");

    if (isAlreadySelected) {
      // If the option is already selected, deselect it
      link.classList.remove("filter-item--active");
      link.removeAttribute("aria-current");

      // Remove from selectedParts array
      const index = this.selectedParts.indexOf(linkHandle);
      if (index !== -1) {
        this.selectedParts.splice(index, 1);
      }
    } else {
      // If the option is not selected, deselect other options in the same category
      this.deselectOtherOptions(filterType);

      // Select the new option
      link.classList.add("filter-item--active");
      link.setAttribute("aria-current", 'true');
      this.selectedParts.push(linkHandle);
    }

    // Show or hide the clear button based on active selections
    if (document.querySelectorAll('.filter-item--active').length > 0) {
      this.clear.classList.remove('hidden');
    } else {
      this.clear.classList.add('hidden');
    }

    document.getElementById('selected-items-count').innerHTML = `(${document.querySelectorAll('.filter-item--active').length})`;

    // Update the URL to reflect the selected filters
    this.updateUrl();
  }


  deselectOtherOptions(filterType) {
    // Find all active options in the same filter category and deactivate them
    this.filterLinks.forEach(link => {
      const linkHandle = link.getAttribute("data-handle");
      if (linkHandle && linkHandle.startsWith(filterType) && link.classList.contains("filter-item--active")) {
        link.classList.remove("filter-item--active");
        link.removeAttribute("aria-current");

        // Remove from selectedParts array
        const index = this.selectedParts.indexOf(linkHandle);
        if (index !== -1) {
          this.selectedParts.splice(index, 1);
        }
      }
    });
  }



  updateUrl() {
    this.url = `${this.collectionUrl}/${this.selectedParts.join("+")}`;
    window.history.replaceState(null, null, this.url);
  }

  applyFilters() {
    this.url = `${this.collectionUrl}/${this.selectedParts.join("+")}`;
    window.location.href = this.url;
  }

  addClickOutsideListener() {
   document.addEventListener("mousedown", (event) => {
    if (this.filterContainer && !this.filterContainer.contains(event.target) && !this.toggleBtn.contains(event.target)){
      this.closeFilter();
    }
   });
  }

  toggleFilter() {
    const isOpen = this.filterContainer.getAttribute('default-open') === 'true';
    if (isOpen) {
      this.closeFilter();
    } else {
      this.openFilter();
      this.scrollToFilterContainer();
    }
  }

  scrollToFilterContainer() {
    const filterContainerRect = this.filterContainer.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Check if the filter container is in the viewport
    const isContainerVisible = (filterContainerRect.top >= 0 && filterContainerRect.bottom <= windowHeight);

    // If the filter container is out of view, scroll the page to bring it into view
    if (!isContainerVisible) {
      window.scrollTo({
        top: filterContainerRect.top + window.scrollY - 60, // Adjust scroll position to center the filter container
        behavior: 'smooth'
      });
    }
  }


  openFilter() {
    this.filterContainer.setAttribute('default-open', 'true');
    document.body.classList.add('overflow-hidden');
    document.body.classList.add('no-scroll');
    document.querySelector('html').classList.add('overflow-hidden');
  }

  closeFilter() {
    this.filterContainer.setAttribute('default-open', 'false');
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('no-scroll');
    document.querySelector('html').classList.remove('overflow-hidden');
  }
}

const init = () => {
  if (!customElements.get("product-filters")) {
    customElements.define('product-filters', ProductFilters);
  }
};

init();
